import React from 'react';

/**
 * Error boundary that catches JavaScript crashes and shows a friendly message.
 * Prevents blank screens on older devices (e.g., iPhone 7 / iOS 15).
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('App crashed:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', minHeight: '100vh', padding: '24px',
          fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
          textAlign: 'center', background: '#fff',
        }}>
          <h1 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '12px', color: '#1a1a1a' }}>
            Something went wrong
          </h1>
          <p style={{ fontSize: '16px', color: '#666', maxWidth: '400px', lineHeight: 1.5, marginBottom: '24px' }}>
            The app encountered an error. Please try refreshing the page or clearing your browser cache.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: '#7c3aed', color: '#fff', border: 'none', borderRadius: '12px',
              padding: '12px 32px', fontSize: '16px', fontWeight: 600, cursor: 'pointer',
            }}
          >
            Refresh Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
